import { createRoutine } from 'redux-saga-routines';
import dotProp from 'dot-prop-immutable';
import { last } from 'lodash';

export const routines = {
  openModal: createRoutine('OPEN_MODAL'),
  closeModal: createRoutine('CLOSE_MODAL'),
  closeAndOpenModal: createRoutine('CLOSE_AND_OPEN_MODAL'),
  closeAllModals: createRoutine('CLOSE_ALL_MODALS')
};

const initialState = {
  activeModals: []
};

function reducer(state = initialState, { type, payload }) {
  let nextState = state;
  const { activeModals = [] } = state;
  switch (type) {
    case routines.openModal.TRIGGER:
      nextState = dotProp.set(nextState, 'activeModals', [
        ...activeModals,
        { name: payload.name, data: payload.data, display: payload.display }
      ]);
      break;
    case routines.closeModal.TRIGGER:
      activeModals.pop();
      nextState = dotProp.set(nextState, 'activeModals', activeModals);
      break;
    case routines.closeAllModals.TRIGGER:
      nextState = dotProp.set(nextState, 'activeModals', []);
      break;
    default:
      break;
  }
  return nextState;
}

export const activeModalSelector = state => last(state.ui.modals.activeModals);

export default reducer;
